import React from 'react';
import { Typography } from '@mui/material';

const AnimatedTitle = ({ 
  text = "Animated Title", 
  variant = "h3",
  color = "primary",
  delay = 0.05,
  repeatInterval = 5 // in seconds
}) => {
  const letters = text.split('');
  const totalLetters = letters.length;
  const animationDuration = repeatInterval;

  return (
    <div style={{ overflow: 'hidden', display: 'inline-block' }}>
      <Typography 
        variant={variant}
        component="div"
        style={{ 
          ml: 0,
          display: 'inline-flex',
          color: color === 'primary' ? '#7091e6' : color
        }}
      >
        {letters.map((letter, index) => (
          <span
            key={index}
            className="animated-letter"
            style={{
              animation: `slideDown ${animationDuration}s ease-out infinite`,
              animationDelay: `${index * delay}s`,
              // animationDelay: `${letterDelay}s`,
              display: 'inline-block',
              whiteSpace: 'pre'
            }}
          >
            {letter}
          </span>
        ))}
      </Typography>

      <style>{`
        @keyframes slideDown {
          0%, ${((totalLetters * delay) / animationDuration) * 100}%  {
            opacity: 0;
            transform: translateY(-20px);
          }
          ${((totalLetters * delay) / animationDuration) * 100 + 10}%, 100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animated-letter {
          opacity: 0;
        }
      `}</style>
    </div>
  );
};
export default AnimatedTitle;

// .animated-letter {
//           animation: slideDown 0.5s ease-out forwards;
//           opacity: 0;
//         }
// Demo
// export default function App() {
//   return (
//     <div style={{ 
//       padding: '40px',
//       backgroundColor: '#1a1a2e',
//       minHeight: '100vh',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '40px',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }}>
//       <AnimatedTitle 
//         text="Welcome to My App" 
//         variant="h2"
//       />
      
//       <AnimatedTitle 
//         text="Beautiful Animations" 
//         variant="h4"
//         color="#adbbda"
//         delay={0.03}
//       />
      
//       <AnimatedTitle 
//         text="Letter by Letter Effect" 
//         variant="h5"
//         color="#3d52a0"
//         delay={0.07}
//       />
//     </div>
//   );
// }